import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

import {
    Button,
    Card,
    Form,
    HelperText,
    InputGroup,
    Spinner,
} from "@deere/ux.uxframe-react";

import MachineList from "./MachineList";
import {
    getMachineDetails,
    getMachines,
    machineDetails,
    machineListError,
    machineListLoading,
    machinesList,
    resetMachineState,
    searchedPin,
    setSearchedPin,
} from "./machineSearchSlice";
import {useHistory, useParams} from "react-router-dom";
import {languageResponseData} from "../Translation/translationSerachSlice";
 

const MachineSearch = () => {
    const translationsResponse = useSelector(languageResponseData);
    const translate = (key, defaultText) => {
        return translationsResponse[key] || defaultText;
    };

    const dispatch = useDispatch();
    const history = useHistory();

    const serialNum = useSelector(searchedPin);
    const machines = useSelector(machinesList);
    const machineSearchLoading = useSelector(machineListLoading);
    const machineDetail = useSelector(machineDetails);
   

    const errorMessage = useSelector(machineListError);

    const [searchSerialNum, setSearchSerialNum] = useState("");
    const {serialNumber} = useParams();

 

    useEffect(() => {
        if (serialNumber) setSearchSerialNum(serialNumber);
        else if (serialNum) setSearchSerialNum(serialNum);
    }, [serialNumber, serialNum]);

    const searchSerialNumber = (event) => {
        event.preventDefault();

        if (searchSerialNum.length === 6) {
            const searchObj = {
                searchedPin: searchSerialNum,
                searchType: "partialPin",
            };
            dispatch(setSearchedPin(searchSerialNum));
            dispatch(getMachines(searchObj));
            localStorage.setItem("searchLength", 6);
        } else if (searchSerialNum.length >= 13 && searchSerialNum.length <= 17) {
            /*dispatch(setSearchedPin(searchSerialNum));
            dispatch(getMachineDetails(searchSerialNum));
            localStorage.setItem("searchLength", searchSerialNum.length);*/
            history.push({
                pathname: `/machine-details/pin/${searchSerialNum}`,
                state: {
                    pinNumber: searchSerialNum,
                    machineSearchType: "machines",
                    searchLength: (searchSerialNum ?? "").length,
                },
            });
        }
    };

    const handleSearchSerialNumChange = (e) => {
        setSearchSerialNum(e.target.value.trim().toUpperCase());
    };

    const submitDisabled = () => {
        return !(
            searchSerialNum.length === 6 ||
            (searchSerialNum.length >= 13 && searchSerialNum.length <= 17)
        );
    };

    useEffect(() => {
        const unlisten = history.listen((location, action) => {
            if (!location.pathname.startsWith("/machine-details")) {
                dispatch(resetMachineState());
            }
        });

        return () => {
            unlisten();
        };
    }, [dispatch, history]);

    return (
        <div>
            <Card>
                <Card.Header>
                    <strong>{translate("machinesearch", "Machine Search")}</strong>
                </Card.Header>
                <Card.Body>
                    <HelperText
                        helperTextId="machineSearchHelper"
                        helperText={translate(
                            "message1",
                            "Please enter a partial or complete PIN."
                        )}
                    >
                        <InputGroup className="mb-3 col-8">
                            <Form
                                onSubmit={searchSerialNumber}
                                style={{display: "inline-flex"}}
                            >
                                <Form.Control
                                    aria-label="Machine serial number"
                                    style={{width: "auto", minWidth: "100px"}}
                                    value={searchSerialNum}
                                    onChange={handleSearchSerialNumChange}
                                />
                                <InputGroup.Append>
                                    <Button
                                        variant="primary"
                                        disabled={submitDisabled()}
                                        onClick={searchSerialNumber}
                                    >
                                        {translate("search", "Search")}
                                    </Button>
                                </InputGroup.Append>
                            </Form>
                        </InputGroup>
                    </HelperText>
                    {errorMessage ? (
                        <span
                            style={{
                                color: "red",
                                marginTop: 0.5,
                                fontSize: 20,
                                marginLeft: 300,
                            }}
                        >
              {translate('message16', 'No machines found for this criteria.')}
            </span>
                    ) : (
                        <></>
                    )}
                </Card.Body>
            </Card>
            {machineSearchLoading ? (
                <div className="d-flex w-100 justify-content-center align-items-center">
                    <Spinner
                        accessibilityLabel="Loading"
                        className="uxf-spinner-border-lg"
                        animation="border"
                    />
                </div>
            ) : !machineSearchLoading && machines && machines.length > 0 ? (
                <Card>
                    <Card.Header>
                        <strong>{translate("machine_list", "Machine List")}</strong>
                    </Card.Header>
                    <Card.Body>
                        <MachineList machineSearchType="machines"/>
                    </Card.Body>
                </Card>
            ) : (
                !machineSearchLoading &&
                machineDetail &&
                history.push({
                    pathname: `/machine-details/pin/${searchSerialNum}`,
                    state: {
                        pinNumber: searchSerialNum,
                        machineSearchType: "machines",
                        searchLength: (searchSerialNum ?? "").length,
                    },
                })
            )}
        </div>
    );
};

export default MachineSearch;
